import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { type } from '@app/util/util';

import {
  SearchFlightPayload,
  RequestSearchPayload,
  NewInitialAirSearchPayload,
  NewAirSearchPayload
} from '@flight-results/entities/request-search.payload';
import {
  FlightAmenitie,
  FlightItem,
  FlightResults,
  NewAirResultsResponse
} from '@app/entities/flight-results';
import { FetchFiltersPayload } from '@flight-results/entities/fetch-filters.payload';
import { SearchResultsData } from '@flight-results/entities/search-results-data';
import { FetchFlightsOptionPayload } from '@flight-results/entities/fetch-flights-option.payload';
import { FlexibleDatesPayload } from '@flight-results/entities/flexible-dates.payload';
import { FlexibleDatesResult, FlexibleDatesMappedResult } from '@flight-results/entities/flexible.dates';
import {
  FlightCabin, FlightDetailCabinPayload, FlightResultsCabinPayload
} from '@shared/flight-itinerary/entities/cabin-types';
import { SlackPushPayload } from '@notifications/entities/slack-push';
import { AirFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';

export const searchFlightsAction = createAction(
  type('[FlightResults/API] Search flights'),
  props<{ payload: SearchFlightPayload }>()
);
export const searchFlightsWithTokenAction = createAction(
  type('[FlightResults/API] Search flights with token'),
  props<{ payload: RequestSearchPayload }>()
);
export const searchFlightsSuccessAction = createAction(
  type('[FlightResults/API] Search flights Success'),
  props<{ flightResults: FlightResults }>()
);
export const selectFlightsAction = createAction(
  type('[FlightResults/DATA] Select flights'),
  props<{ flights: FlightItem[] }>()
);
export const fetchAirGroupResultsAction = createAction(
  type('[FlightResults/API] Fetch AirGroup Results'),
  props<{ payload: NewAirSearchPayload, fetchFilters?: boolean }>()
);
export const fetchAirResultsAction = createAction(
  type('[FlightResults/API] Fetch Air Results'),
  props<{ payload: NewAirSearchPayload, fetchFilters?: boolean, paginated?: boolean }>()
);
export const fetchAirResultsBySectorAction = createAction(
  type('[FlightResults/API] Fetch Air Results BySector'),
  props<{ payload: NewAirSearchPayload, fetchFilters?: boolean }>()
);
export const fetchAirGroupResultsSuccessAction = createAction(
  type('[FlightResults/API] Fetch AirGroup Results Success'),
  props<{ flightResults: NewAirResultsResponse }>()
);
export const fetchAirResultsSuccessAction = createAction(
  type('[FlightResults/API] Fetch Air Results Success'),
  props<{ flightResults: NewAirResultsResponse }>()
);
export const fetchAirResultsBySectorSuccessAction = createAction(
  type('[FlightResults/API] Fetch Air Results BySector Success'),
  props<{ flightResults: NewAirResultsResponse }>()
);
export const searchFlexDatesAction = createAction(
  type('[FlightResults/API] Search flexible dates'),
  props<{ payload: FlexibleDatesPayload }>()
);
export const searchFlexDatesMobileSuccessAction = createAction(
  type('[FlightResults/API] Search flexible dates mobile Success'),
  props<{ flexDatesMappedResults: FlexibleDatesMappedResult }>()
);
export const searchFlexDatesSuccessAction = createAction(
  type('[FlightResults/API] Search flexible dates Success'),
  props<{ flexDatesResults: FlexibleDatesResult }>()
);
export const searchFlexDatesErrorAction = createAction(
  type('[FlightResults/API] Search flexible dates Error'),
  props<{ payload: HttpErrorResponse }>()
);
export const mapSearchPayloadToken = createAction(
  type('[FlightResults/API] Map Flight Search Payload'),
  props<{ payload: NewInitialAirSearchPayload }>()
);
export const fetchSearchAndFiltersAction = createAction(
  type('[FlightResults/API] Fetch search and filters'),
  props<{ payload: NewAirSearchPayload, SearchBySector: boolean, isMobile: boolean  }>()
);
export const noResultsSearchFlightsAction = createAction(
  type('[FlightResults/API] No results for flights search')
);
export const fetchFiltersAction = createAction(
  type('[FlightResults/API] Fetch filters'),
  props<{ payload: FetchFiltersPayload, results: NewAirResultsResponse }>()
);
export const fetchFiltersBySectorAction = createAction(
  type('[FlightResults/API] Fetch filters by sector'),
  props<{ payload: FetchFiltersPayload, results: NewAirResultsResponse }>()
);
export const fetchFiltersSuccessAction = createAction(
  type('[FlightResults/API] Fetch filters success'),
  props<{ filters: AirFiltersResponse }>()
);
export const saveFlightSearchData = createAction(
  type('[FlightResults/DATA] Save search data'),
  props<{ data: SearchResultsData }>()
);
export const clearFlightResultsAction = createAction(
  type('[FlightResults/DATA] Clear flights results'),
  props<{ isMobile: boolean }>()
);
export const fetchFlightsOptionAction = createAction(
  type('[FlightResults/API] Fetch flights option'),
  props<{ payload: FetchFlightsOptionPayload }>()
);
export const searchFlightsForMobileErrorAction = createAction(
  type('[FlightResults/Data] FlightResults For Mobile error'),
  props<{ payload: HttpErrorResponse }>()
);
export const searchFlightsForDesktopErrorAction = createAction(
  type('[FlightResults/Data] FlightResults For Desktop error'),
  props<{ payload: HttpErrorResponse }>()
);
export const fetchFlightCabinAction = createAction(
  type('[FlightCabin/API] Fetch flight cabin detail'),
  props<{ payload: FlightDetailCabinPayload }>()
);
export const fetchFlightCabinSuccessAction = createAction(
  type('[FlightCabin/API] Fetch flight cabin detail Success'),
  props<{ flightCabin: FlightCabin }>()
);
export const fetchFlightCabinErrorAction = createAction(
  type('[FlightCabin/API] Fetch flight cabin detail Error'),
  props<{ payload: HttpErrorResponse }>()
);
export const clearFlightResultsCabinAction = createAction(
  type('[FlightResultsCabin/API] Clear flight results cabin detail')
);
export const fetchFlightResultsCabinAction = createAction(
  type('[FlightResultsCabin/API] Fetch flight results cabin detail'),
  props<{ payload: FlightResultsCabinPayload }>()
);
export const fetchFlightResultsCabinSuccessAction = createAction(
  type('[FlightResultsCabin/API] Fetch flight results cabin detail Success'),
  props<{ itineraryId: number, amenities: FlightAmenitie[] }>()
);
export const fetchFlightResultsCabinErrorAction = createAction(
  type('[FlightResultsCabin/API] Fetch flight results cabin detail Error'),
  props<{ payload: HttpErrorResponse }>()
);
export const fetchExchangeTokenAction = createAction(
  type('[UserHistory/API] Exchange search token'),
  props<{ payload: NewAirSearchPayload }>()
);
export const clearFilterAction = createAction(
  type('[FlightResults/API] Clear Filter Action')
);
export const clearSearchPayloadAction = createAction(
  type('[FlightResults/API] Clear Search Payload Action')
);
export const clearSearchResultDataAction = createAction(
  type('[FlightResults/API] Clear Search Result Data Action')
);
export const slackResidualExchangePushAction = createAction(
  type('[Notification/Slack] Residual exchange push by slack'),
  props<{ payload: SlackPushPayload }>()
);
export const slackResidualExchangePushSuccessAction = createAction(
  type('[Notification/Slack] Residual exchange push by slack success')
);

export const disabledFlightScrollAction = createAction(
  type('[FlightResults/UI] Disabled flight scroll'),
  props<{ payload: boolean }>()
);

export const setShowedDetailsAction = createAction(
  type('[FlightResults/UI] Set showd details in flights'),
  props<{ payload: string }>()
);

export const setFlightResultsLoadingAction = createAction(
  type('[FlightResults/DATA] Set flights results loading'),
  props<{ payload: boolean }>()
);
